webpackJsonp([57],{

/***/ "/Qfn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c83ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("/Qfn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "27Cd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("HSTt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HSTt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kf/3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = saveUser;
/* harmony export (immutable) */ __webpack_exports__["e"] = getUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearUser;
/* harmony export (immutable) */ __webpack_exports__["f"] = saveCollege;
/* unused harmony export getCollege */
/* harmony export (immutable) */ __webpack_exports__["a"] = clearCollege;
/* harmony export (immutable) */ __webpack_exports__["g"] = saveHistorySearch;
/* harmony export (immutable) */ __webpack_exports__["d"] = getHistorySearch;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearHistorySearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


var USER_KEY = '__user__';

function saveUser(query) {
	var val = query.expired || 1000 * 60 * 60 * 24 * 30; //30天; 1天 //1000 * 60 * 60 * 24
	query.expired = new Date().getTime() + val;
	localStorage.setItem(USER_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(query));
	return query;
}

function getUser() {
	var val = JSON.parse(localStorage.getItem(USER_KEY));
	if (!val) {
		return;
	}
	var nowTime = new Date().getTime();
	var oldTime = val.expired;
	if (nowTime > oldTime) {
		clearUser();
		return;
	}
	return val;
}

function clearUser() {
	localStorage.removeItem(USER_KEY);
	return undefined;
}

var COLLEGE_KEY = '__college__';

function saveCollege(query) {
	localStorage.setItem(COLLEGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(query));
	return query;
}

function getCollege() {
	return JSON.parse(localStorage.getItem(COLLEGE_KEY));
}

function clearCollege() {
	localStorage.removeItem(COLLEGE_KEY);
	return undefined;
}

var HISTORY_KEY = '__history__';

function saveHistorySearch(query) {
	if (query.length >= 8) {
		query.length = 8;
	}

	localStorage.setItem(HISTORY_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(query));
	return query;
}

function getHistorySearch() {
	return JSON.parse(localStorage.getItem(HISTORY_KEY));
}

function clearHistorySearch() {
	localStorage.removeItem(HISTORY_KEY);
	return undefined;
}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var actions_namespaceObject = {};
__webpack_require__.d(actions_namespaceObject, "saveUserAction", function() { return actions_saveUserAction; });
__webpack_require__.d(actions_namespaceObject, "clearUserAction", function() { return actions_clearUserAction; });
__webpack_require__.d(actions_namespaceObject, "saveCollegeAction", function() { return actions_saveCollegeAction; });
__webpack_require__.d(actions_namespaceObject, "clearCollegeAction", function() { return actions_clearCollegeAction; });
__webpack_require__.d(actions_namespaceObject, "saveHistorySearchAction", function() { return actions_saveHistorySearchAction; });
__webpack_require__.d(actions_namespaceObject, "clearHistorySearchAction", function() { return actions_clearHistorySearchAction; });
var getters_namespaceObject = {};
__webpack_require__.d(getters_namespaceObject, "user", function() { return user; });
__webpack_require__.d(getters_namespaceObject, "college", function() { return college; });
__webpack_require__.d(getters_namespaceObject, "history_search", function() { return history_search; });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/common/js/cache.js
var cache = __webpack_require__("Kf/3");

// EXTERNAL MODULE: ./src/api/home.js
var home = __webpack_require__("xO/y");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/common/js/config.js
var config = __webpack_require__("W/7t");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var App = ({
  name: "app",
  data: function data() {
    return {
      statis: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['college'])),
  created: function created() {
    (function (doc, win) {
      var docEl = doc.documentElement,
          resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
          recalc = function recalc() {
        var clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        var val = Number(200 * (clientWidth / 750));
        docEl.style.fontSize = val > 200 ? "200px" : val + "px";
      };

      if (!doc.addEventListener) return;
      win.addEventListener(resizeEvt, recalc, false);
      doc.addEventListener("DOMContentLoaded", recalc, false);
    })(document, window);

    //获取用户
    if (Object(cache["e" /* getUser */])()) {} else {
      this.$store.commit('CLEAR_USER');
    }
  },
  mounted: function mounted() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: "app",
  data: function data() {
    return {
      statis: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['college'])),
  created: function created() {
    (function (doc, win) {
      var docEl = doc.documentElement,
          resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
          recalc = function recalc() {
        var clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        var val = Number(200 * (clientWidth / 750));
        docEl.style.fontSize = val > 200 ? "200px" : val + "px";
      };

      if (!doc.addEventListener) return;
      win.addEventListener(resizeEvt, recalc, false);
      doc.addEventListener("DOMContentLoaded", recalc, false);
    })(document, window);

    //获取用户
    if (Object(cache["e" /* getUser */])()) {} else {
      this.$store.commit('CLEAR_USER');
    }
  },
  mounted: function mounted() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e231ced","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['HomePage','LessionPage','Learn','My']}},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"statis",domProps:{"innerHTML":_vm._s(_vm.statis)}}),_vm._v(" "),_c('div',{staticClass:"baidu"})],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("27Cd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// CONCATENATED MODULE: ./src/router/exam.js

var EXAM_HOME = function EXAM_HOME() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "NzKZ"));
};
var DAY_PRACTICE = function DAY_PRACTICE() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(__webpack_require__.bind(null, "BLHy"));
};
// 真题
var TRUE_TOPIC = function TRUE_TOPIC() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(__webpack_require__.bind(null, "WmMv"));
};
// 开始真题
var START_TRUE_EXAM = function START_TRUE_EXAM() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(49)]).then(__webpack_require__.bind(null, "6oac"));
};
var ASSESSMENT = function ASSESSMENT() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(__webpack_require__.bind(null, "64P8"));
};
// 错题
var WRONG = function WRONG() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(__webpack_require__.bind(null, "TJX5"));
};
// 收藏
var COLLECT = function COLLECT() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(54)]).then(__webpack_require__.bind(null, "uL92"));
};
// 错题集
var QUESTION_RECORD = function QUESTION_RECORD() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, "fPQ0"));
};
// 答题卡
var ANSWER_SHEET = function ANSWER_SHEET() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(53)]).then(__webpack_require__.bind(null, "f9oW"));
};
// 考试课程
var EXAM_COURSE = function EXAM_COURSE() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "cfVl"));
};
// 章节练习
var EXAM_CHAPTER = function EXAM_CHAPTER() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(47)]).then(__webpack_require__.bind(null, "/42t"));
};
// 章节  开始做题
var EXAM_CHANPTER_START = function EXAM_CHANPTER_START() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(__webpack_require__.bind(null, "giqQ"));
};
// 模拟考试
var MOCK_EXAM_LIST = function MOCK_EXAM_LIST() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(50)]).then(__webpack_require__.bind(null, "3d34"));
};
// 开始模拟考试
var MOCK_EXAM = function MOCK_EXAM() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(__webpack_require__.bind(null, "ZM8h"));
};
// 错题解析
var WRONG_ANALYSIS = function WRONG_ANALYSIS() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(43)]).then(__webpack_require__.bind(null, "o7ub"));
};
// CONCATENATED MODULE: ./src/router/integral.js
var integral = function integral() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(__webpack_require__.bind(null, "mxDQ"));
};
var integrallist = function integrallist() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(__webpack_require__.bind(null, "zQUD"));
};
// CONCATENATED MODULE: ./src/router/index.js
var _this = this;







var HomePage = function HomePage() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "y4L9"));
};
var Live = function Live() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "OxPH"));
};
var Lession = function Lession() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "JjGU"));
};
var LessionDetail = function LessionDetail() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "HB5L"));
};
var Learn = function Learn() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "FS/b"));
};
var LearnDetail = function LearnDetail() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "sPq8"));
};
var LessionList = function LessionList() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(55)]).then(__webpack_require__.bind(null, "ZUhm"));
};

var my = function my() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "h59G"));
};
var personInfo = function personInfo() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, "AJ0M"));
};
var orderList = function orderList() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(__webpack_require__.bind(null, "/HhV"));
};
var collect = function collect() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(__webpack_require__.bind(null, "AS/+"));
};
var study = function study() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, "G+UY"));
};
var feedback = function feedback() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(__webpack_require__.bind(null, "aYKq"));
};
var message = function message() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(52)]).then(__webpack_require__.bind(null, "uWSM"));
};
var aboutme = function aboutme() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(__webpack_require__.bind(null, "xuXq"));
};
var download = function download() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, "/ekw"));
};
var login = function login() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(__webpack_require__.bind(null, "Ntyz"));
};
var register = function register() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, "mrsp"));
};
var watch = function watch() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(__webpack_require__.bind(null, "uzxN"));
};
var notfound = function notfound() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "DMMP"));
};
var pay = function pay() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(45)]).then(__webpack_require__.bind(null, "PDQ4"));
};
var payorder = function payorder() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(44)]).then(__webpack_require__.bind(null, "4a52"));
};
var address = function address() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(__webpack_require__.bind(null, "zpod"));
};

var classify = function classify() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(51)]).then(__webpack_require__.bind(null, "b/fc"));
};
var search = function search() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "JDFc"));
};
var packagelist = function packagelist() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(__webpack_require__.bind(null, "5kna"));
};
var childinfo = function childinfo() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, "FSHS"));
};
var livelist = function livelist() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(46)]).then(__webpack_require__.bind(null, "G3yZ"));
};
var graduation = function graduation() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(48)]).then(__webpack_require__.bind(null, "SegF"));
};

var joinIndex = function joinIndex() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "qALo"));
};
var joinForm = function joinForm() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "CZl1"));
};

var rule = function rule() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(__webpack_require__.bind(null, "ngDW"));
};
//注销账号
var logout = function logout() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "SKAl"));
};
var logoutcode = function logoutcode() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(__webpack_require__.bind(null, "XlOk"));
};

var vipMember = function vipMember() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "46LL"));
};
var vipCourse = function vipCourse() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, "70ZW"));
};
var vipCourseNew = function vipCourseNew() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(__webpack_require__.bind(null, "Sxpq"));
};
var vipCourseRecord = function vipCourseRecord() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(33)]).then(__webpack_require__.bind(null, "8VV3"));
};

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/HomePage'
  }, {
    path: '/HomePage',
    name: 'HomePage',
    component: HomePage
  }, {
    path: '/rule',
    name: 'rule',
    component: rule
  },
  // 课程列表页
  {
    path: '/LessionList',
    name: 'LessionList',
    component: LessionList
  }, {
    path: '/Live',
    name: 'Live',
    component: Live
  }, {
    path: '/Lession',
    name: 'Lession',
    component: Lession
  }, {
    path: '/Learn',
    name: 'Learn',
    component: Learn
  }, {
    path: '/LearnDetail',
    name: 'LearnDetail',
    component: LearnDetail
  }, {
    path: '/LessionDetail',
    name: 'LessionDetail',
    component: LessionDetail
  },
  //classify
  {
    path: '/classify',
    name: 'classify',
    component: classify
  }, {
    path: '/my',
    name: 'My',
    component: my
  }, {
    path: '/personinfo',
    name: 'personInfo',
    component: personInfo
  }, {
    path: '/orderlist',
    name: 'orderList',
    component: orderList
  }, {
    path: '/collect',
    name: 'collect',
    component: collect
  }, {
    path: '/study',
    name: 'study',
    component: study
  }, {
    path: '/feedback',
    name: 'feedback',
    component: feedback
  }, {
    path: '/message',
    name: 'message',
    component: message
  }, {
    path: '/aboutme',
    name: 'aboutme',
    component: aboutme
  }, {
    path: '/download',
    name: 'download',
    component: download
  }, {
    path: '/login',
    name: 'login',
    component: login
  }, {
    path: '/register',
    name: 'register',
    component: register
  }, {
    path: '/watch/:id',
    name: 'watch',
    component: watch
  }, {
    path: '*',
    name: 'notfound',
    component: notfound
  }, {
    path: '/pay/:id',
    name: 'pay',
    component: pay
  }, {
    path: '/payorder',
    name: 'payorder',
    component: payorder
  }, {
    path: '/address',
    name: 'address',
    component: address
  }, {
    path: '/search',
    name: 'search',
    component: search
  }, {
    path: '/packagelist', //package 类型
    name: 'packagelist',
    component: packagelist
  }, {
    path: '/childinfo',
    name: 'childinfo',
    component: childinfo
  }, {
    path: '/livelist',
    name: 'livelist',
    component: livelist
  }, {
    path: '/graduation',
    name: 'graduation',
    component: graduation
  },
  // 考试一类
  {
    path: '/examCourse',
    name: 'examCourse',
    component: EXAM_COURSE
  }, {
    path: '/exam',
    name: 'exam',
    component: EXAM_HOME
  }, {
    path: '/DayPractice',
    name: 'DayPractice',
    component: DAY_PRACTICE
  }, {
    path: '/TrueTopic',
    name: 'TrueTopic',
    component: TRUE_TOPIC
  }, {
    path: '/Assessment',
    name: 'Assessment',
    component: ASSESSMENT
  }, {
    path: '/Wrong',
    name: 'Wrong',
    component: WRONG
  }, {
    path: '/CollectTopic',
    name: 'CollectTopic',
    component: COLLECT
  }, {
    path: '/QuestionRecord',
    name: 'QuestionRecord',
    component: QUESTION_RECORD
  }, {
    path: '/AnswerSheet',
    name: 'AnswerSheet',
    component: ANSWER_SHEET
  }, {
    path: '/ExamChapter',
    name: 'ExamChapter',
    component: EXAM_CHAPTER
  }, {
    path: '/ExamStartChapter',
    name: 'ExamStartChapter',
    component: EXAM_CHANPTER_START
  }, {
    path: '/MockExamList',
    name: 'MockExamList',
    component: MOCK_EXAM_LIST
  }, {
    path: '/StartMockExam',
    name: 'StartMockExam',
    component: MOCK_EXAM
  }, {
    path: '/StartTrueExam',
    name: 'StartTrueExam',
    component: START_TRUE_EXAM
  }, {
    path: '/WrongAnlysis',
    name: 'WrongAnlysis',
    component: WRONG_ANALYSIS
  }, {
    path: '/joinIndex',
    name: 'joinIndex',
    component: joinIndex
  }, {
    path: '/joinForm',
    name: 'joinForm',
    component: joinForm
  }, {
    path: '/integral',
    name: 'integral',
    component: integral
  }, {
    path: '/integrallist',
    name: 'integrallist',
    component: integrallist
  }, {
    path: '/logoutcode',
    name: 'logoutcode',
    component: logoutcode
  }, {
    path: '/logout',
    name: 'logout',
    component: logout
  }, {
    path: '/vip-member',
    name: 'vip-member',
    component: vipMember
  }, {
    path: '/vip-course',
    name: 'vip-course',
    component: vipCourse
  }, {
    path: '/vip-course-new',
    name: 'vip-course-new',
    component: vipCourseNew
  }, {
    path: '/vip-course-record',
    name: 'vip-course-record',
    component: vipCourseRecord
  }]
});

var originalPush = vue_router_esm["a" /* default */].prototype.push;
vue_router_esm["a" /* default */].prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};

var routeList = ['exam', 'DayPractice', 'TrueTopic', 'Assessment', 'Wrong', 'CollectTopic', 'QuestionRecord', 'AnswerSheet', 'ExamChapter', 'ExamStartChapter', 'MockExamList', 'StartMockExam', 'StartTrueExam', 'WrongAnlysis', 'integral'];

// 路由守卫
// 进入特定页面前判断是否已登录，未登录跳转到登录页面
router.beforeEach(function (to, from, next) {
  if (routeList.indexOf(to.name) > -1) {
    if (!Object(cache["e" /* getUser */])()) {
      console.log(_this.$router);
      next({ name: 'login' });
    }
  }
  next();
});

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/store/mutation-types.js

var SET_USER = 'SET_USER';
var CLEAR_USER = 'CLEAR_USER';

var SET_COLLEGE = 'SET_COLLEGE';

var SET_HISTORY_SEARCH = 'SET_HISTORY_SEARCH';
// CONCATENATED MODULE: ./src/store/actions.js



var actions_saveUserAction = function saveUserAction(_ref, query) {
	var commit = _ref.commit;

	commit(SET_USER, Object(cache["h" /* saveUser */])(query));
};

var actions_clearUserAction = function clearUserAction(_ref2) {
	var commit = _ref2.commit;

	commit(SET_USER, Object(cache["c" /* clearUser */])());
	commit(CLEAR_USER);
};

var actions_saveCollegeAction = function saveCollegeAction(_ref3, query) {
	var commit = _ref3.commit;

	commit(SET_COLLEGE, Object(cache["f" /* saveCollege */])(query));
};

var actions_clearCollegeAction = function clearCollegeAction(_ref4) {
	var commit = _ref4.commit;

	commit(SET_COLLEGE, Object(cache["a" /* clearCollege */])());
};

var actions_saveHistorySearchAction = function saveHistorySearchAction(_ref5, query) {
	var commit = _ref5.commit;

	console.log(query);
	commit(SET_HISTORY_SEARCH, Object(cache["g" /* saveHistorySearch */])(query));
};

var actions_clearHistorySearchAction = function clearHistorySearchAction(_ref6) {
	var commit = _ref6.commit;

	commit(SET_HISTORY_SEARCH, Object(cache["b" /* clearHistorySearch */])());
};
// CONCATENATED MODULE: ./src/store/getters.js

var user = function user(state) {
  return state.user;
};

var college = function college(state) {
  return state.college;
};

var history_search = function history_search(state) {
  return state.history_search;
};
// CONCATENATED MODULE: ./src/store/state.js



var state = {
	user: Object(cache["e" /* getUser */])(),
	// user: {
	// 	id: 2,
	// 	showname: '你的名字',
	// 	nickname:'ni陈'
	// },
	history_search: Object(cache["d" /* getHistorySearch */])(),
	college: { id: 0 //getCollege()
	} };

/* harmony default export */ var store_state = (state);
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _mutations;



var mutations = (_mutations = {}, defineProperty_default()(_mutations, SET_USER, function (state, value) {
  state.user = value;
}), defineProperty_default()(_mutations, CLEAR_USER, function (state) {
  state.user = null;
}), defineProperty_default()(_mutations, SET_COLLEGE, function (state, value) {
  state.college = value;
}), defineProperty_default()(_mutations, SET_HISTORY_SEARCH, function (state, value) {
  state.history_search = value;
}), _mutations);

/* harmony default export */ var store_mutations = (mutations);
// EXTERNAL MODULE: ./node_modules/vuex/dist/logger.js
var logger = __webpack_require__("sax8");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// CONCATENATED MODULE: ./src/store/index.js









vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
	actions: actions_namespaceObject,
	getters: getters_namespaceObject,
	state: store_state,
	mutations: store_mutations,
	strict: debug,
	plugins: debug ? [logger_default()()] : []
}));
// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// EXTERNAL MODULE: ./node_modules/vue-meta/dist/vue-meta.esm.js
var vue_meta_esm = __webpack_require__("f3bp");

// EXTERNAL MODULE: ./src/common/js/util.js
var util = __webpack_require__("hhm8");

// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.esm.js
var vue_lazyload_esm = __webpack_require__("AXdl");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// CONCATENATED MODULE: ./src/main.js













vue_esm["a" /* default */].directive('transfer-dom', transfer_dom["a" /* default */]);

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

vue_esm["a" /* default */].use(vue_meta_esm["a" /* default */]);


vue_esm["a" /* default */].use(vue_lazyload_esm["a" /* default */], {
  loading: __webpack_require__("gOYj"),
  error: __webpack_require__("gOYj")
});





vue_esm["a" /* default */].use(toast["a" /* default */]);
vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);
vue_esm["a" /* default */].use(loading["a" /* default */]);

fastclick_default.a.attach(document.body);
vue_esm["a" /* default */].config.productionTip = false;

src_router.afterEach(function (to, from) {

  if (Object(util["b" /* browserMobile */])().isPc) {
    if (to.name == 'joinIndex') {
      window.open(window.location.origin + '/joinUs/index.html', '_self');
    } else if (to.name == 'joinForm') {
      window.open(window.location.origin + '/joinUs/joinForm.html', '_self');
    }
  }
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: src_router,
  store: store,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "Qt4p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W/7t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return host; });
/* unused harmony export childWebsite */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticHost; });
/* unused harmony export payVipUrl */
/* unused harmony export sellType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return windowWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return windowHeight; });

var host = ''; //'/xhykt'小程序里

var childWebsite =  false ? 'http://ke.xhce.cn' : window.location.host; // 'http://ke.xhce.cn' //'10.18.0.127:8033' ''

var staticHost = 'https://xiaochengxu.xhe.cn/xhyktimg'; //'http://kestatic.xhe.cn'
// export const staticHost = 'http://wantongstatic.91miwei.com'

var payVipUrl = host + '/to/alipay';

var sellType = {
	'COURSE': 'course',
	'COURSECHAPTERS': 'mulcourse',
	'PACKAGE': 'package'
};

var windowWidth = document.documentElement.clientWidth;
var windowHeight = document.documentElement.clientHeight; // window.screen.availHeight//

/***/ }),

/***/ "ZI/m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gOYj":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "hhm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export debounce */
/* unused harmony export throttle */
/* harmony export (immutable) */ __webpack_exports__["c"] = clickToBack;
/* harmony export (immutable) */ __webpack_exports__["b"] = browserMobile;
/* harmony export (immutable) */ __webpack_exports__["a"] = addIntegral;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_home__ = __webpack_require__("xO/y");


function debounce(func, delay) {
	var delay = delay || 200;
	var timer = void 0;
	return function () {
		var _this2 = this;

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(function () {
			func.apply(_this2, args);
		}, delay);
	};
}

function throttle(fn) {
	var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

	var lock = false;
	return function () {
		if (lock) return;
		fn.apply(undefined, arguments);
		lock = true;
		setTimeout(function () {
			lock = false;
		}, delay);
	};
}

function clickToBack(_this) {
	var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;


	_this.$router.go(n);
}

function browserMobile() {
	var ua = window.navigator.userAgent,
	    isWindowsPhone = /(?:Windows Phone)/.test(ua),
	    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
	    isAndroid = /(?:Android)/.test(ua),
	    isFireFox = /(?:Firefox)/.test(ua),
	    isChrome = /(?:Chrome|CriOS)/.test(ua),
	    isTablet = /(?:iPad|PlayBook)/.test(ua) || isAndroid && !/(?:Mobile)/.test(ua) || isFireFox && /(?:Tablet)/.test(ua),
	    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
	    isPc = !isPhone && !isAndroid && !isSymbian;
	return {
		isTablet: isTablet,
		isPhone: isPhone,
		isAndroid: isAndroid,
		isPc: isPc
	};
}

// 积分
function addIntegral(data) {
	Object(__WEBPACK_IMPORTED_MODULE_0__api_home__["b" /* addIntegralOper */])(data).then(function (res) {
		data = res.entity;
	});
}

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd202a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Qt4p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rC09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export encryptDes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_tools_md5_index_js__ = __webpack_require__("SWtL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_tools_number_random_js__ = __webpack_require__("5Pkd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_alert_module__ = __webpack_require__("+zLN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cache__ = __webpack_require__("Kf/3");









__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (res) {
  if (res.data.code && res.data.code.trim() == '401') {
    __WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_alert_module__["a" /* default */].show({
      title: '',
      content: res.data.message,
      maskZIndex: 3000,
      onHide: function onHide() {
        Object(__WEBPACK_IMPORTED_MODULE_6__cache__["c" /* clearUser */])();

        window.location.href = 'http://ke.xhe.cn/login';
      }
    });
  }
  if (res.config && res.status) {
    return res.data;
  }
  return res;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {

  var getTime = new Date().getTime();
  var randomValue = Object(__WEBPACK_IMPORTED_MODULE_3_vux_src_tools_number_random_js__["a" /* default */])(100000, 999999);

  var base = encryptDes(getTime.toString(), '!x@h#y$1');

  var mima = '';
  var getuserid = 0;
  var getuservalue = Object(__WEBPACK_IMPORTED_MODULE_6__cache__["e" /* getUser */])();

  if (getuservalue && getuservalue.customerkey) {
    mima = Object(__WEBPACK_IMPORTED_MODULE_2_vux_src_tools_md5_index_js__["a" /* default */])(base + randomValue + getuservalue.customerkey);
    getuserid = getuservalue.id;
  } else {
    mima = Object(__WEBPACK_IMPORTED_MODULE_2_vux_src_tools_md5_index_js__["a" /* default */])(base + randomValue);
  }

  config.headers['time'] = getTime;
  config.headers['random'] = randomValue;
  config.headers['digest'] = mima;
  config.headers['userId'] = getuserid;
  config.headers['collegeId'] = 0;
  config.headers['channel'] = 'h5';

  return config;
}, function (error) {

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

var encryptDes = function encryptDes(message, key) {
  var afterEncrypt = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.DES.encrypt(message, __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.enc.Utf8.parse(key), {
    mode: __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.mode.ECB,
    padding: __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.pad.Pkcs7
  }).toString();

  return afterEncrypt;
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ZI/m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xO/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getHomeData */
/* unused harmony export getHomeList */
/* harmony export (immutable) */ __webpack_exports__["p"] = getHomeBanner;
/* harmony export (immutable) */ __webpack_exports__["j"] = getCommentGood;
/* harmony export (immutable) */ __webpack_exports__["a"] = DelCollect;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCollect;
/* harmony export (immutable) */ __webpack_exports__["t"] = getNote;
/* harmony export (immutable) */ __webpack_exports__["v"] = getQuestion;
/* harmony export (immutable) */ __webpack_exports__["y"] = getVideoTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = getBuyfree;
/* harmony export (immutable) */ __webpack_exports__["q"] = getHotList;
/* harmony export (immutable) */ __webpack_exports__["h"] = getCollegeType;
/* harmony export (immutable) */ __webpack_exports__["l"] = getCourseList;
/* harmony export (immutable) */ __webpack_exports__["n"] = getCoursesDetail;
/* harmony export (immutable) */ __webpack_exports__["k"] = getCourseChapter;
/* harmony export (immutable) */ __webpack_exports__["m"] = getCourseType;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCollegeProType;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCollegeProTypeCourse;
/* harmony export (immutable) */ __webpack_exports__["i"] = getComment;
/* harmony export (immutable) */ __webpack_exports__["s"] = getMyLession;
/* harmony export (immutable) */ __webpack_exports__["d"] = getChildInfo;
/* harmony export (immutable) */ __webpack_exports__["o"] = getGraduation;
/* harmony export (immutable) */ __webpack_exports__["u"] = getOuterVideo;
/* harmony export (immutable) */ __webpack_exports__["b"] = addIntegralOper;
/* harmony export (immutable) */ __webpack_exports__["B"] = postPersonal;
/* harmony export (immutable) */ __webpack_exports__["w"] = getRule2;
/* harmony export (immutable) */ __webpack_exports__["x"] = getUserRecord;
/* harmony export (immutable) */ __webpack_exports__["r"] = getMemberCourseList;
/* unused harmony export getTypeList */
/* harmony export (immutable) */ __webpack_exports__["A"] = memberCourseStudyTotal;
/* harmony export (immutable) */ __webpack_exports__["z"] = memberCourseStudyList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_axios__ = __webpack_require__("rC09");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_config__ = __webpack_require__("W/7t");
//首页接口



/*示例*/
function getHomeData(data) {
	var url = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/valueadded/courseinfo';
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: url,
		params: data
	});
}

var BANNER = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/index/banner';

var COLLEGEPROTYPECOURSE = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/college/courseList';

var COLLEGEPROTYPE = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/querySubjectByCollegeProType'; //课程选择 分类

var CHILDWEBSITEINFO = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/collegeInfo';

var COLLEGETYPE = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/collegeProTypeList';

var GETGRADUATION = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/valueadded/getUserCertificateInfo';

// 课程列表
var COURSELIST = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/college/queryCourseList'; // '/app/college/courseList'

// 多章节课程详情页
var COURSESDETAIL = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/valueadded/courseinfo';
// 章节
var COURSECHAPTER = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/valueadded/coursechapter';
// 课程分类
var COURSETYPE = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/college/websiteCourseList';
// 热门课程
var HOTCOURSELIST = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/college/queryHotCourseList';
// 评论列表
var COMMENT = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/course/comment/list';
// 我的课程
var MYLESIION = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/uc/course';
// 收藏
var COLLECT = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/course/addfavorites';
// 取消收藏
var DEL_COLLECT = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/collection/cleanFavorites';
// 评论点赞
var COMMENTGOOD = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/course/commentpraise';
// 首页接口
var HOMELIST = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/college/queryCollegeProperty';
// 获取笔记接口
var NOTE = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/course/note/list';
// 获取问答接口
var QUESTION = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/course/question/list';
// 视频播放时间
var VIDEOTIME = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/valueadded/addloglearn';
// 购买免费课程
var BUYFREE = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/order/buyFreeCourse';
// 添加积分
var INTEGRAL = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/userCollegeIntegral/add';

//获取outer视频
var OUTERVIDEO = __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/kpoint/outerUrl';

// 获取首页信息
function getHomeList(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: HOMELIST,
		data: data,
		method: "POST"
	});
}

function getHomeBanner(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: BANNER,
		params: data
	});
}

// 评论点赞
function getCommentGood(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: COMMENTGOOD,
		params: data,
		method: "GET"
	});
}

// 取消收藏

function DelCollect(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: DEL_COLLECT,
		params: data,
		method: "GET"
	});
}

// 收藏
function getCollect(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: COLLECT,
		params: data,
		method: "GET"
	});
}

//笔记
function getNote(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: NOTE,
		params: data,
		method: "GET"
	});
}

//问答
function getQuestion(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: QUESTION,
		params: data,
		method: "GET"
	});
}
//视频播放时间
function getVideoTime(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: VIDEOTIME,
		params: data,
		method: "GET"
	});
}
//购买免费课程
function getBuyfree(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: BUYFREE,
		params: data,
		method: "GET"
	});
}

// 获取热门课程
function getHotList(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: HOTCOURSELIST,
		params: data,
		method: "GET"
	});
}

// 获取课程大分类
function getCollegeType(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: COLLEGETYPE,
		params: data,
		method: "GET"
	});
}
// 获取课程数据
function getCourseList(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: COURSELIST,
		params: data,
		method: "GET"
	});
}

//课程详情
function getCoursesDetail(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: COURSESDETAIL,
		params: data,
		method: "GET"
	});
}
// 章节
function getCourseChapter(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: COURSECHAPTER,
		params: data,
		method: "GET"
	});
}
// 课程分类
function getCourseType(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: COURSETYPE,
		params: data,
		method: "GET"
	});
}

//课程选择分类 classify
function getCollegeProType(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: COLLEGEPROTYPE,
		params: data
	});
}
//课程选择分类下 课程 classify
function getCollegeProTypeCourse(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: COLLEGEPROTYPECOURSE,
		params: data
	});
}

// 评论列表
function getComment(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: COMMENT,
		params: data,
		method: "GET"
	});
}
// 我的课程列表
function getMyLession(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: MYLESIION,
		params: data,
		method: "GET"
	});
}

//获取子站点信息
function getChildInfo(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: CHILDWEBSITEINFO,
		params: data
	});
}

//结业证书
function getGraduation(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: GETGRADUATION,
		params: data
	});
}

// OUTER视频
function getOuterVideo(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: OUTERVIDEO,
		params: data,
		method: "GET"
	});
}

// 添加积分
function addIntegralOper(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: INTEGRAL,
		params: data,
		method: "GET"
	});
}

// 提交个人信息
function postPersonal(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/user/update/info',
		params: data,
		method: "GET"
	});
}

function getRule2(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/userCollegeIntegral/ruleList',
		params: data,
		method: "GET"
	});
}

//vip 会员
function getUserRecord(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/member/userRecord',
		params: data
	});
}
//vip会员课程列表
function getMemberCourseList(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/member/memberCourseList',
		params: data
	});
}

//vip会员类型列表接口
function getTypeList(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/member/typeList',
		params: data
	});
}

//vip学习记录汇总数据接口
function memberCourseStudyTotal(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/member/memberCourseStudyTotal',
		params: data
	});
}

//vip学习记录分页数据接口
function memberCourseStudyList(data) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__common_js_axios__["a" /* default */])({
		url: __WEBPACK_IMPORTED_MODULE_1__common_js_config__["a" /* host */] + '/app/member/memberCourseStudyList',
		params: data
	});
}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1c353e121dfc5c741e39.js